/* eslint
    @typescript-eslint/no-shadow: "warn",
*/

import easyfyAxios from '@shared/easyfy.axios';

namespace Easyfy.Web.Services.Search {
  export interface ISearchData {
    includeBrands: boolean;
    includePages: boolean;
    includeCampaigns: boolean;
    searchTerm: string;
    partialView?: string;
    hideSuggestions?: boolean;
  }

  export const Search = async (
    data: ISearchData,
    token: string
  ): Promise<any> => {
    const url = `/search`;
    return easyfyAxios.post(
      url,
      data,
      token
    );
  };

  export const GetAutoCompleteInitView = async (
  ): Promise<any> => {
    const url = `/api/autocomplete?handler=initsearch`;
    return easyfyAxios.get(
      url);
  };
}

export default Easyfy.Web.Services.Search;
